import type { paths } from '@luxuryescapes/contract-trip/dist/server'
import request from 'api/requestUtils'
import { baseUri, getOptions } from 'tripPlanner/api/utils'

export type IntelligentTripSuggestionRequest =
  paths['/api/trips/intelligent-trip-suggestions']['post']['requestBody']['content']['application/json']

export type IntelligentTripSuggestionResponse =
  paths['/api/trips/intelligent-trip-suggestions']['post']['responses']['200']['content']['application/json']

export type IntelligentTripSuggestionEnvelope = IntelligentTripSuggestionResponse['result']

export type NLPResponseOption = NonNullable<IntelligentTripSuggestionResponse['result']['options']>[number]

export async function generateIntelligentTripSuggestions(
  payload: IntelligentTripSuggestionRequest,
  signal?: AbortSignal,
): Promise<IntelligentTripSuggestionEnvelope> {
  const response = await request.post<IntelligentTripSuggestionResponse, IntelligentTripSuggestionRequest>(
    `${baseUri}/intelligent-trip-suggestions`,
    payload,
    { ...getOptions(), signal, cache: 'no-store' },
  )

  return response.result
}
